export default {
  'slot-all': {
    search: { slot: true },
    form: { slot: true },
    rowSlot: true
  },
  slot: {
    form: { slot: true },
    rowSlot: true
  },
  'slot-form': {
    form: { slot: true }
  }
}
